import WageDeduction from './wage-deduction';

export default WageDeduction;
